import React, { useEffect, useState, useRef } from "react";
import { Box, CssBaseline, TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import DataGridComponent from "./DataGridComponent";
import { useDispatch, useSelector } from "react-redux";
import { getTenantDetail } from "../../features/tenantDetail/tenantDetailAction";
import moment from "moment";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [tenants, setTenants] = useState([]);
  const [searchText, setSearchText] = useState("");
  const searchDebounceRef = useRef();
  const hasFetched = useRef(false);
  const tenantList = useSelector((state) => state.tenantDetail);

  useEffect(()=> {
    if (tenantList?.data?.length) {
      const filteredData = tenantList.data.map((row) => ({
        id: row?.tenantId,
        tenant: row?.name,
        status: row?.status === "Approved" ? "Active" : row?.status,
        expiration: row?.expirationDate ? moment(row.expirationDate).format("DD-MM-YYYY") : "",
        createdOn: row?.created?.on ? moment(row.created.on).format("DD-MM-YYYY") : "",
      }));
      setTenants(filteredData)
    } else {
      setTenants([]);
    }
  }, [tenantList])

  useEffect(()=> {
    if (!hasFetched.current) {
      getTenantDetailsData();
      hasFetched.current = true;
    }
  },[])

  const getTenantDetailsData = (searchValue = "") => {
    dispatch(getTenantDetail({ search: !!searchValue, searchText: searchValue }));
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }
    searchDebounceRef.current = setTimeout(() => {
      getTenantDetailsData(value);
    }, 400);
  };

  const handleSearch = () => {
    getTenantDetailsData(searchText);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSearchClear = () => {
    setSearchText("");
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }
    getTenantDetailsData("");
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", marginTop: '50px' }}>
      <CssBaseline/>
      <Box sx={{ width: '300px', margin: '20px 0 0 20px' }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search customer"
          value={searchText}
          onChange={handleSearchChange}
          onKeyDown={handleKeyDown}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchText ? (
                  <IconButton onClick={handleSearchClear}>
                    <CloseIcon />
                  </IconButton>
                ) : (
                  <IconButton onClick={handleSearch}>
                    <SearchIcon />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <DataGridComponent rows={tenants} setRows={setTenants}/>
    </Box>
  );
};

export default Dashboard;
